import { useMainContext } from "../../../../context";
import { useCartContext } from "../../context";
import { IoCarOutline, IoStorefrontOutline } from "react-icons/io5";
import { useCallback, useEffect, useMemo } from "react";
import AddressForm from "../../../../components/addressForm";
import InputLabel from "../../../../components/inputLabel";

const CartWayOfDelivery = () => {
  const { restaurant, order } = useMainContext();

  const {
    deliveryType,
    setDeliveryType,
    findDeliveryPrice,
    changeTableNumber,
  } = useCartContext();

  const avaiableDeliveryMethod = useMemo(
    () => restaurant?.settings?.delivery_method,
    [restaurant],
  );

  const renderDeliveryMethod = useCallback(
    (method) => {
      const Icon = method.icon;
      let buttonState = method.disabled ? "disabled" : "default";

      if (deliveryType === method.id) {
        buttonState = "active";
      }

      const buttonClasses = {
        disabled:
          "cursor-not-allowed border-gray-300 bg-gray-100 text-gray-400",
        active: "border-primary-500 bg-primary-100/50 text-primary-800",
        default: "rounded-md border-2 transition-colors text-gray-700",
      };

      const iconClasses = {
        disabled: "bg-gray-400 text-white",
        active: "bg-primary-800 text-white",
        default: "bg-gray-300/50 text-gray-700",
      };

      return (
        <button
          disabled={method.disabled}
          onClick={() => setDeliveryType(method.id)}
          key={method.id}
          className={`rounded-md border-2 transition-colors ${buttonClasses[buttonState]}`}
        >
          <div className="px-4 py-4 flex items-center gap-5 md:gap-3">
            <div
              className={`rounded-full w-12 h-12 md:w-16 md:h-16 flex items-center justify-center transition-colors ${iconClasses[buttonState]}`}
            >
              <Icon className="w-7 h-7 md:w-8 md:h-8 transition-colors" />
            </div>
            <div className="flex flex-col items-start">
              <span className="text-left leading-tight font-black text-xl">
                {method.label}
              </span>
              <span className="text-left leading-tight text-sm mt-1">
                {method.description}
              </span>
            </div>
          </div>
        </button>
      );
    },
    [deliveryType, setDeliveryType],
  );

  const renderBalconyInfo = useCallback(
    () => (
      <>
        <h4 className="font-bold text-lg mb-4 break-words">QUAL A SUA MESA?</h4>

        <InputLabel
          label="Número da mesa:"
          type="number"
          value={order.tableNumber}
          onChange={(event) => changeTableNumber(event.target.value)}
        />
      </>
    ),
    [order, changeTableNumber],
  );

  const renderDeliveryInfo = useCallback(
    () => (
      <>
        <h4 className="font-bold text-lg mb-4 break-words">
          ENDEREÇO DE ENTREGA
        </h4>

        <div className="flex flex-col gap-1">
          <AddressForm />
        </div>
      </>
    ),
    [],
  );

  const deliveryMethods = [
    {
      id: "delivery",
      label: "Delivery",
      description: "Entregamos no seu endereço",
      icon: IoCarOutline,
      disabled: avaiableDeliveryMethod === "balcony_only",
      info: renderDeliveryInfo,
    },
    {
      id: "balcony",
      label: "Comer no restaurante",
      description: "Retirar ou consumir no local",
      icon: IoStorefrontOutline,
      disabled: avaiableDeliveryMethod === "delivery_only",
      info: renderBalconyInfo,
    },
  ];

  useEffect(() => {
    findDeliveryPrice();
  }, []);

  return (
    <>
      <h2 className="text-2xl font-black break-words uppercase text-black border-l-4 border-primary-500 pl-4 mb-6">
        COMO VOCÊ DESEJA RECEBER?
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
        {deliveryMethods.map(renderDeliveryMethod)}
      </div>

      {deliveryType && (
        <div className="mt-4 flex flex-1 flex-col border-2 border-gray-200 rounded-xl p-4 shadow-sm">
          {deliveryMethods.find((m) => m.id === deliveryType)?.info()}
        </div>
      )}
    </>
  );
};

export default CartWayOfDelivery;
